// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5386": "a50c4516","5545": "20927b2f","7869": "22f405b2",}[chunkId] + ".css"
}